import { ResponsiveTabsList, ResponsiveTabsTrigger } from "@/components/admin/ResponsiveTabsComponents";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { Heart, Activity, Settings, Webhook } from "lucide-react";
import { SystemHealthDashboard } from "./SystemHealthDashboard";
import { SystemMetricsPanel } from "./SystemMetricsPanel";
import { MaintenanceManager } from "./MaintenanceManager";
import { WebhookSettings } from "../webhooks/WebhookSettings";

export function HealthManager() {
  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div>
          <h2 className="text-xl sm:text-2xl font-bold flex items-center gap-2">
            <Heart className="h-5 w-5 sm:h-6 sm:w-6 text-red-500" />
            System Health
          </h2>
          <p className="text-muted-foreground text-sm sm:text-base">
            Monitor system status, performance metrics, and manage maintenance windows
          </p>
        </div>
      </div>

      <Tabs defaultValue="health" className="space-y-4 sm:space-y-6">
        <ResponsiveTabsList>
          <ResponsiveTabsTrigger 
            value="health" 
            icon={<Heart className="h-4 w-4" />}
            label="Health Status"
            mobileLabel="Health"
          />
          <ResponsiveTabsTrigger 
            value="metrics" 
            icon={<Activity className="h-4 w-4" />}
            label="System Metrics"
            mobileLabel="Metrics"
          />
          <ResponsiveTabsTrigger 
            value="webhooks" 
            icon={<Webhook className="h-4 w-4" />}
            label="Webhooks"
            mobileLabel="Webhooks"
          />
          <ResponsiveTabsTrigger 
            value="maintenance" 
            icon={<Settings className="h-4 w-4" />}
            label="Maintenance"
            mobileLabel="Maintenance"
          />
        </ResponsiveTabsList>

        <TabsContent value="health" className="space-y-4">
          <SystemHealthDashboard />
        </TabsContent>

        <TabsContent value="metrics" className="space-y-4">
          <SystemMetricsPanel />
        </TabsContent>

        <TabsContent value="webhooks" className="space-y-4">
          <WebhookSettings />
        </TabsContent>

        <TabsContent value="maintenance" className="space-y-4">
          <MaintenanceManager />
        </TabsContent>
      </Tabs>
    </div>
  );
}